import { render } from "./SentenceAssemblyExerciseComponent.vue?vue&type=template&id=6c46ca50&scoped=true"
import script from "./SentenceAssemblyExerciseComponent.vue?vue&type=script&lang=js"
export * from "./SentenceAssemblyExerciseComponent.vue?vue&type=script&lang=js"

import "./SentenceAssemblyExerciseComponent.vue?vue&type=style&index=0&id=6c46ca50&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c46ca50"]])

export default __exports__